import { apiGet } from "./http";

export type PlatformRegisteredUserRow = {
  id: string;
  wxOpenId: string;
  nickName: string;
  phoneNumber: string;
  avatarUrl: string;
  createdAtUtc: string;
  lastSeenAtUtc: string;
};

export async function fetchPlatformRegisteredUsers(params?: {
  tenantLegacyId?: string;
  q?: string;
  skip?: number;
  take?: number;
}): Promise<PlatformRegisteredUserRow[]> {
  const qs = new URLSearchParams();
  if (params?.tenantLegacyId) qs.set("tenantLegacyId", params.tenantLegacyId);
  if (params?.q) qs.set("q", params.q);
  if (typeof params?.skip === "number") qs.set("skip", String(params.skip));
  if (typeof params?.take === "number") qs.set("take", String(params.take));
  const query = qs.toString();
  return apiGet<PlatformRegisteredUserRow[]>(`/api/platform/registered-users${query ? `?${query}` : ""}`);
}

